// @flow

import type { DependencyObjectType, ExpandedSpecificationDTO } from './Types/Field'
import type { ProductContent } from './Types/ProductContent'
import type { TranslationType } from './Types/TranslationTypes'

export const generateTexts = (specification: ExpandedSpecificationDTO, productContent: ProductContent,
                              rootTypes: any = {}): TranslationType | boolean => {
  if (specification && specification.fields && productContent && productContent.fieldOrder) {
    const fieldProcessed = specification.fields.reduce((acc, fieldSpecification) => {
      acc[fieldSpecification.name] = fieldSpecification
      return acc
    }, {})
    let fieldTypesProcessed = specification.types.reduce((acc, typeSpecification) => {
      acc[typeSpecification.name] = typeSpecification
      return acc
    }, {})
    if (!specification.types.length) {
      fieldTypesProcessed = rootTypes
    }
    return productContent.fieldOrder.reduce((acc, fieldName) => {
      if (fieldProcessed[fieldName]) {
        if (['object', 'array'].includes(fieldProcessed[fieldName].domain._type)) {
          acc[fieldName] = {
            _name: productContent.fieldNames[fieldName]
              ? productContent.fieldNames[fieldName]
              : fieldName
          }
          if (fieldProcessed[fieldName].domain.specification && fieldTypesProcessed[fieldProcessed[fieldName].domain.specification.name]) {
            const texts = generateTexts(
              fieldProcessed[fieldName].domain.specification,
              productContent.types[fieldProcessed[fieldName].domain.specification.name],
              fieldTypesProcessed
            )
            if (texts) {
              acc[fieldName] = Object.assign(acc[fieldName], texts)
            }
          }
        } else if (productContent.fieldNames[fieldName]) {
          acc[fieldName] = productContent.fieldNames[fieldName]
        } else {
          acc[fieldName] = fieldName
        }
      }
      return acc
    }, {})
  } else {
    return false
  }
}

export const getAssociatedFields = (productContent: ProductContent, associatedFields: any = {}) => {
  if (productContent) {
    if (productContent.components) {
      associatedFields = Object.keys(productContent.components).reduce((acc, componentKey: string) => {
        if (productContent.components[componentKey].associated) {
          const component = productContent.components[componentKey]
          acc[component.parent] = {
            ...component,
            rendered: false,
            items: []
          }
        }
        return acc
      }, associatedFields)
    }
    if (productContent.types) {
      associatedFields = Object.keys(productContent.types).reduce((contentKey: string) =>
        getAssociatedFields(productContent.types[contentKey], associatedFields), associatedFields)
    }
  }
  return associatedFields
}

export const getDependencyArray = (depObject: DependencyObjectType) =>
  Object.keys(depObject).reduce((acc, depValueKey) => {
    depObject[depValueKey].forEach((depValue) => {
      if (depValue.includes('values.')) {
        const key = depValue.split('.')[1] // get only first level (values.policyHolder.phoneNumber => policyHolder)
        if (!acc.includes(key)) {
          acc.push(key)
        }
      }
    })
    return acc
  }, [])

export const getAllDependencies = (specification: ExpandedSpecificationDTO) => {
  return specification.types.reduce((acc, typeSpecification) => {
    if (typeSpecification.dependencies && Object.keys(typeSpecification.dependencies).length) {
      const dArray = getDependencyArray(typeSpecification.dependencies)
      dArray.forEach((key) => {
        if (!acc.includes(key)) {
          acc.push(key)
        }
      })
    }
    return acc
  }, [])
}
